import ContratoInterceptor from '../ContratoInterceptor'

const api = new ContratoInterceptor()

export default {
  addPlanosOperadora(contradoId: String, grupoRemuneracaoId: String, operadoraId: String, planosOperadora: String[]) {
    return api.post(`/contratos/${contradoId}/grupos-remuneracao/${grupoRemuneracaoId}/operadoras/${operadoraId}/planos-operadora`, planosOperadora)
  },

  removePlanoOperadora(contradoId: String, grupoRemuneracaoId: String, operadoraId: String, planoOperadoraId: String) {
    return api.delete(`/contratos/${contradoId}/grupos-remuneracao/${grupoRemuneracaoId}/operadoras/${operadoraId}/planos-operadora/${planoOperadoraId}`)
  },
}
